export default __webpack_public_path__ + "static/media/jen-health.d1c7fe4a.webp";